import { PHONE_FIELDS } from '../../redux/configuration/constants'

export function getFieldsAndLayout(
  signedIn,
  defaultToVehicleOptionsList,
  hasVehicle
) {
  const allFieldNames = [
    'title',
    'firstName',
    'lastName',
    'address',
    'city',
    'countryCode',
    'county',
    'postalCode',
    'licensePlateNumber',
    'licensePlateProvince',
    'licensePlateRental',
    `workPhoneNumber`,
    'mobilePhoneNumber',
    'homePhoneNumber',
    'emailAddress',
    'emailAddressConfirm'
  ]
  const contactRows = PHONE_FIELDS.useSplitLayout
    ? [
        ['licensePlateNumber', 'licensePlateProvince'],
        [...PHONE_FIELDS.client],
        ['emailAddress', 'emailAddressConfirm']
      ]
    : [
        [
          'licensePlateNumber',
          [...PHONE_FIELDS.client],
          'emailAddress',
          'emailAddressConfirm'
        ]
      ]
  const allFieldLayout = [
    ['title', 'firstName', 'lastName'],
    ['address', 'city'],
    ['countryCode', 'county', 'postalCode'],
    ...contactRows
  ]
  const keysToRemove = {
    emailAddressConfirm: signedIn,
    licensePlateNumber: !defaultToVehicleOptionsList || !hasVehicle,
    licensePlateProvince: !defaultToVehicleOptionsList || !hasVehicle,
    licensePlateRental: !defaultToVehicleOptionsList || !hasVehicle,
    title: process.env.REACT_APP_FLOW_CLIENT_ID !== 'mai'
  }
  PHONE_FIELDS.all.forEach(phoneField => {
    if (!PHONE_FIELDS.client.includes(phoneField)) {
      keysToRemove[phoneField] = true
    }
  })
  const filterKeys = arr => arr.filter(x => !keysToRemove[x])

  return {
    fields: filterKeys(allFieldNames),
    layout: allFieldLayout.map(row => filterKeys(row))
  }
}
